'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dList$002dProxies$002dPage$0024 from "./presto.-List-Proxies-Page$.js";
import * as $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002483 from "./presto.-Presto-Router$$anon$83.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$82() {
  this.bn6 = null;
  this.bmY = null;
  this.bmZ = false;
  this.bn7 = null;
  this.bn8 = false;
  this.bnb = null;
  this.bn4 = null;
  this.bn5 = false;
  this.bn0 = null;
  this.bn1 = false;
  this.bn2 = null;
  this.bn3 = false;
  this.bn9 = false;
  this.bna = false;
  this.bn6 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bnb = "ListProxiesPage";
}
export { $c_Lpresto_PrestoRouter$$anon$82 as $c_Lpresto_PrestoRouter$$anon$82 };
$p = $c_Lpresto_PrestoRouter$$anon$82.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$82;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$82() {
}
export { $h_Lpresto_PrestoRouter$$anon$82 as $h_Lpresto_PrestoRouter$$anon$82 };
$h_Lpresto_PrestoRouter$$anon$82.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.bn6;
});
$p.M = (function() {
  if ((!this.bmZ)) {
    this.bmY = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.bmZ = true;
  }
  return this.bmY;
});
$p.O = (function() {
  if ((!this.bn8)) {
    this.bn7 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.bn8 = true;
  }
  return this.bn7;
});
$p.E = (function() {
  return this.bnb;
});
$p.t = (function() {
  if ((!this.bn5)) {
    this.bn4 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bn5 = true;
  }
  return this.bn4;
});
$p.N = (function() {
  if ((!this.bn1)) {
    this.bn0 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bn1 = true;
  }
  return this.bn0;
});
$p.Q = (function() {
  if ((!this.bn3)) {
    this.bn2 = new $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002483.$c_Lpresto_PrestoRouter$$anon$83();
    this.bn3 = true;
  }
  return this.bn2;
});
$p.v = (function() {
  if ((!this.bna)) {
    this.bn9 = false;
    this.bna = true;
  }
  return this.bn9;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee542) => ((p) => \u03b4scrutinee542))($j_presto$002e$002dList$002dProxies$002dPage$0024.$m_Lpresto_ListProxiesPage$())));
});
var $d_Lpresto_PrestoRouter$$anon$82 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$82, "presto.PrestoRouter$$anon$82", ({
  P0: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$82 as $d_Lpresto_PrestoRouter$$anon$82 };
//# sourceMappingURL=presto.-Presto-Router$$anon$82.js.map
